module.exports = __webpack_public_path__ + "static/media/9_MTA - New York City.df54d8c9.jpg";